import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Notification from "../components/Notification";
import { FiPlus, FiSearch, FiEye, FiEdit2, FiMoreHorizontal } from "react-icons/fi";
import Popover from "../components/ui/Popover";
import Modal from "../components/modal";
import TimePickerField from '../components/TimePickerField';
import { getTimeSlots } from "../api/reusableApis";

const apiUrl = process.env.REACT_APP_API_URL;
const apiKey = process.env.REACT_APP_API_KEY;
const headers_obj = {
    headers: {
        'ZCFKEY': apiKey
    }
}
function TimeSlot() {

    const [timeslot, setTimeSlot] = useState([]);
    const [toast, setToast] = useState({ message: "", type: "success" });
    const [loader, setLoader] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [errors, setErrors] = useState({});
    const [searchTerm, setSearchTerm] = useState("");
    const [mode, setMode] = useState("add");
    const [formData, setFormData] = useState({
        start_time: "12:00 AM",
        end_time: "12:00 AM",
        label: "12:00 AM - 12:00 AM",
    });

    const colors = ["bg-blue-100 text-blue-700", "bg-green-100 text-green-700", "bg-purple-100 text-purple-700", "bg-pink-100 text-pink-700", "bg-yellow-100 text-yellow-700", "bg-purple-100 text-purple-700", "bg-red-100 text-red-700", "bg-teal-100 text-teal-700",];

    // Fetch all time slots
    const fetchTimeSlots = async () => {
        try {
            setLoader(true);
            const res = await getTimeSlots();
            console.log(res, 'data');
            if (res) {
                setTimeSlot(res);
            } else {
                setToast({ message: "Failed to fetch time slots", type: "error" });
            }
        } catch (error) {
            console.error("Error fetching time slots:", error);
            setToast({ message: "Error fetching time slots", type: "error" });
        } finally {
            setLoader(false);
        }
    };

    const timeToMinutes = (timeStr) => {
        const [timePart, period] = timeStr.split(" ");
        let [hours, minutes] = timePart.split(":").map(Number);
        if (period === "PM" && hours !== 12) hours += 12;
        if (period === "AM" && hours === 12) hours = 0;
        return hours * 60 + minutes;
    };

    const getColorByLabel = (label) => {
        let hash = 0;
        for (let i = 0; i < label.length; i++) {
            hash = label.charCodeAt(i) + ((hash << 5) - hash);
        }
        return colors[Math.abs(hash) % colors.length];
    };

    const formatDateOnly = (dateString) => {
        if (!dateString) return "-";

        const iso = dateString.replace(" ", "T").replace(/:(\d{3})$/, ".$1");
        const date = new Date(iso);

        if (isNaN(date)) return "-";

        return date.toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
        });
    };

    const isValidTime = (time) => {
        if (!time) return false;

        // Assume format is "hh:mm AM/PM"
        const match = time.match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i);
        if (!match) return false;

        const hours = parseInt(match[1], 10);
        const minutes = parseInt(match[2], 10);

        if (minutes < 0 || minutes > 59) return false;
        if (hours < 1 || hours > 12) return false; // 12-hour format
        return true;
    };


    const closeModal = () => setOpenModal(false);

    // Open modal with mode and optional slot data
    const handleOpenModal = (mode, slot = null) => {
        setMode(mode);
        if (slot) {
            setFormData({
                ROWID: slot.ROWID,
                start_time: slot.start_time,
                end_time: slot.end_time,
                label: slot.label,
                sort_order: slot.sort_order,
                CREATEDTIME: slot.CREATEDTIME,
                MODIFIEDTIME: slot.MODIFIEDTIME,
                CREATORID: slot.CREATORID,
            });
        } else {
            // Reset for new slot
            setFormData({
                start_time: "12:00 AM",
                end_time: "12:00 AM",
                label: "12:00 AM - 12:00 AM",
            });
        }
        setOpenModal(true);
    };

    const filteredTimeSlots = timeslot
        ?.filter(slot => {
            const label = slot?.label?.toLowerCase() || "";
            const startTime = slot?.start_time?.toLowerCase() || "";
            const endTime = slot?.end_time?.toLowerCase() || "";
            const term = searchTerm.toLowerCase();

            return (
                label.includes(term) ||
                startTime.includes(term) ||
                endTime.includes(term)
            );
        })
        .sort((a, b) => {
            const dateA = new Date(a?.CREATEDTIME || 0);
            const dateB = new Date(b?.CREATEDTIME || 0);
            return dateB - dateA; // newest first
        });



    // Add or Update time slot
    const handleSubmit = async () => {
        setErrors({}); // clear previous errors

        if (!formData.start_time || !formData.end_time) {
            setErrors({ time: "Start time and End time cannot be empty" });
            return;
        }

        const startMinutes = timeToMinutes(formData.start_time);
        const endMinutes = timeToMinutes(formData.end_time);


        if (!isValidTime(formData.start_time) || !isValidTime(formData.end_time)) {
            setErrors({ time: "Invalid time format or minutes exceed 59" });
            return;
        }


        // if (startMinutes >= endMinutes) {
        //     setErrors({ time: "Start time must be before end time" });
        //     return; // stop submission
        // }


        try {
            let finaljson = {
                start_time: formData.start_time,
                end_time: formData.end_time,
                label: formData.start_time + " - " + formData.end_time,
            };

            closeModal();

            if (mode === "add") {
                const res = await axios.post(apiUrl + "/createTimeSlot", finaljson, headers_obj);
                if (res.status === 200) {
                    setToast({ message: "Time slot added successfully", type: "success" });
                    fetchTimeSlots();
                }
            } else if (mode === "edit") {
                const res = await axios.put(apiUrl + "/updateTimeSlotById/" + formData.ROWID, finaljson, headers_obj);
                if (res.status === 200) {
                    setToast({ message: "Time slot updated successfully", type: "success" });
                    fetchTimeSlots();
                }
            }
            setSearchTerm("");
        } catch (error) {
            console.error("Error saving time slot:", error);
            setToast({ message: "Failed to save time slot", type: "error" });
        }
    };


    useEffect(() => {
        fetchTimeSlots();
    }, []);

    return (
        <>
            <Notification
                message={toast.message}
                type={toast.type}
                onClose={() => setToast({ message: "", type: "success" })}
            />

            {/* ---------- Modal ---------- */}
            <Modal
                open={openModal}
                onClose={closeModal}
                title={
                    mode === "view"
                        ? "Time Slot Details"
                        : mode === "edit"
                            ? "Edit Time Slot"
                            : "Add New Time Slot"
                }
                width="w-full sm:w-[95%] md:max-w-2xl"
                info="Please provide time slot details below"
            >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                    {/* Full-width label on first row */}
                    <FormInput
                        label="Label"
                        value={formData.start_time + " - " + formData.end_time}
                        onChange={(val) => setFormData({ ...formData, label: val })}
                        readOnly={true}   // use boolean, not "view"
                        className="w-full col-span-2"
                    />

                    {/* Start and End times on next row */}
                    <TimePickerField
                        label="Start Time"
                        mode={mode === "view" ? "view" : "edit"}
                        value={formData.start_time}
                        onChange={(val) => setFormData({ ...formData, start_time: val })}
                    />

                    <TimePickerField
                        label="End Time"
                        mode={mode === "view" ? "view" : "edit"}
                        value={formData.end_time}
                        onChange={(val) => setFormData({ ...formData, end_time: val })}
                    />

                </div>
                {errors.time && (
                    <span className="text-[11px] text-rose-500 mt-1 ml-1 font-medium italic block">
                        {errors.time}
                    </span>
                )}

                <div className="mt-6 flex justify-end gap-3 pt-6 border-t border-slate-100">
                    {/* Discard button: always visible */}
                    <button
                        onClick={closeModal}
                        className="px-6 py-2.5 rounded-xl text-sm font-bold text-slate-500 hover:bg-slate-100 transition-colors"
                    >
                        Discard
                    </button>

                    {/* Save/Invite button: only in edit/add mode */}
                    {mode !== "view" && (
                        <button
                            onClick={handleSubmit}
                            className="px-8 py-2.5 rounded-xl bg-slate-900 text-white text-sm font-bold shadow-lg shadow-slate-200 hover:bg-purple-600 transition-all active:scale-95"
                        >
                            {mode === "edit" ? "Save Changes" : "Create Slot"}
                        </button>
                    )}
                </div>

            </Modal>

            {loader ? (
                <div className="flex items-center justify-center min-h-[60vh] w-full">
                    <div className="w-8 h-8 border-4 border-gray-300 border-t-[#22C55E] rounded-full animate-spin"></div>
                </div>
            ) : (
                <div className="flex-1 px-4 sm:px-6 py-6 pt-20 lg:pt-6 bg-gradient-to-br from-slate-50 via-white to-slate-100 min-h-screen h-screen overflow-y-auto">

                    {/* ---------- Header ---------- */}
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
                        <div>
                            <h1 className="text-3xl font-bold tracking-tight text-[#72398E]">Time Slots</h1>
                            <p className="text-sm text-slate-500">Manage Time Slots</p>
                        </div>
                        <div className="flex gap-3 w-full sm:w-auto">
                            <button
                                onClick={() => handleOpenModal("add")}
                                className="flex items-center gap-2 bg-[#72398E] text-white px-5 py-2 rounded-xl shadow-md  transition"
                            >
                                <FiPlus /> Add Time Slot
                            </button>
                        </div>
                    </div>

                    {/* ---------- Filter Bar ---------- */}
                    <div className="bg-white rounded-xl shadow-md border border-slate-200 p-4 flex flex-col sm:flex-row gap-4 mb-6">
                        <div className="flex items-center gap-2 border border-slate-300 rounded-xl px-4 py-2 flex-1 bg-slate-50 focus-within:ring-2 focus-within:ring-slate-900">
                            <FiSearch className="text-slate-400" />
                            <input
                                placeholder="Search Time slots"
                                className="bg-transparent outline-none text-sm w-full"
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="hidden md:block bg-white rounded-xl shadow-lg overflow-hidden max-h-[60vh] overflow-y-auto">
                        <table className="w-full text-sm">
                            <thead className="bg-slate-100 text-slate-500 uppercase text-xs tracking-wider">
                                <tr>
                                    <th className="p-4 text-left">Slot</th>
                                    <th className="text-center">Start Time</th>
                                    <th className="text-center">End Time</th>
                                    <th className="text-center">Modified Time</th>
                                    <th className="text-center">Created Time</th>
                                    <th className="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y">
                                {filteredTimeSlots.map((slot) => (
                                    <tr key={slot.ROWID} className="hover:bg-slate-50 transition">
                                        <td className="p-4">
                                            <span
                                                className={`inline-flex items-center rounded-full px-4 py-1 text-sm font-semibold ${getColorByLabel(slot.label)}`}
                                            >
                                                {slot.label}
                                            </span>
                                        </td>
                                        <td className="text-center text-slate-600">{slot.start_time}</td>
                                        <td className="text-center text-slate-600">{slot.end_time}</td>
                                        <td className="text-center text-slate-600">{formatDateOnly(slot.MODIFIEDTIME)}</td>
                                        <td className="text-center text-slate-600">{formatDateOnly(slot.CREATEDTIME)}</td>
                                        <td className="pr-6 text-right">
                                            <div className="flex justify-center pl-10">
                                                <Popover
                                                    placement="bottom-end"
                                                    trigger={
                                                        <FiMoreHorizontal className="w-5 h-5 cursor-pointer text-slate-500 hover:text-slate-800" />
                                                    }
                                                >
                                                    <button
                                                        onClick={() => handleOpenModal("view", slot)}
                                                        className="flex items-center gap-2 w-full px-4 py-2 text-sm hover:bg-slate-100"
                                                    >
                                                        <FiEye /> View
                                                    </button>

                                                    <button
                                                        onClick={() => handleOpenModal("edit", slot)}
                                                        className="flex items-center gap-2 w-full px-4 py-2 text-sm hover:bg-slate-100"
                                                    >
                                                        <FiEdit2 /> Edit
                                                    </button>
                                                </Popover>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* ---------- Mobile View ---------- */}
                    <div className="md:hidden flex flex-col gap-4">
                        {timeslot.map((slot) => (
                            <div
                                key={slot.ROWID}
                                className="bg-white rounded-xl shadow-md p-4 flex flex-col gap-2 border border-slate-200"
                            >
                                <div className="flex justify-between items-center">
                                    <span
                                        className={`inline-flex items-center rounded-full px-3 py-1 text-sm font-semibold ${getColorByLabel(slot.label)}`}
                                    >
                                        {slot.label}
                                    </span>
                                    <Popover
                                        placement="bottom-end"
                                        trigger={<FiMoreHorizontal className="w-5 h-5 cursor-pointer text-slate-500 hover:text-slate-800" />}
                                    >
                                        <button
                                            onClick={() => handleOpenModal("view", slot)}
                                            className="flex items-center gap-2 w-full px-4 py-2 text-sm hover:bg-slate-100"
                                        >
                                            <FiEye /> View
                                        </button>

                                        <button
                                            onClick={() => handleOpenModal("edit", slot)}
                                            className="flex items-center gap-2 w-full px-4 py-2 text-sm hover:bg-slate-100"
                                        >
                                            <FiEdit2 /> Edit
                                        </button>
                                    </Popover>
                                </div>

                                <div className="grid grid-cols-2 gap-2 text-slate-600 text-sm">
                                    <div>
                                        <span className="font-semibold">Start:</span> {slot.start_time}
                                    </div>
                                    <div>
                                        <span className="font-semibold">End:</span> {slot.end_time}
                                    </div>
                                    <div>
                                        <span className="font-semibold">Created:</span> {formatDateOnly(slot.CREATEDTIME)}
                                    </div>
                                    <div>
                                        <span className="font-semibold">Modified:</span> {formatDateOnly(slot.MODIFIEDTIME)}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>


                </div>
            )}
        </>
    );
}

export default TimeSlot;

// ---------- FormInput component ----------
function FormInput({
    label,
    value,
    onChange,
    placeholder,
    readOnly = false,
    disabled = false,
    type = "text",
    error = null
}) {
    return (
        <div className="flex flex-col">
            <label className="text-xs font-bold text-slate-600 mb-1.5 ml-1 uppercase tracking-wider">
                {label}
            </label>
            <input
                type={type}
                placeholder={placeholder}
                value={value || ""}
                readOnly={readOnly}
                disabled={disabled}
                onChange={(e) => onChange(e.target.value)}
                className={`w-full border rounded-xl px-4 py-2.5 text-sm transition-all outline-none
            ${error ? "border-rose-400 focus:ring-rose-500/20" : "border-slate-200 focus:ring-purple-500/10"}
            ${readOnly || disabled
                        ? "bg-slate-50 text-slate-400 cursor-not-allowed"
                        : "hover:border-slate-300 focus:ring-4 focus:border-purple-500"}
          `}
            />
            {error && (
                <span className="text-[11px] text-rose-500 mt-1 ml-1 font-medium italic">
                    {error}
                </span>
            )}
        </div>
    );
}
